import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_platform_container';

const ids = {
  ...addCyPrefixToIDs(cyPrefix, { BTN_BACK: 'BTN_BACK' }),
  PLATFORM: platform => `PLATFORM_${platform}`,
  PLATFORM_OTHER_INPUT: 'PLATFORM_OTHER_INPUT',
};

export const CY_PLATFORM_CONTAINER_IDS = ids;

export const OTHER_VALUE = 'Other';

export const T_PREFIX = 'products-fe.containers.platform';
